export const fontCombination = [
    {
        "id": "ellipse_e7d89517-80de-47bc-8a8f-9d3008d89e43",
        "type": "text",
        "text": [
            "SALE"
        ],
        "top": 442.27272727272725,
        "rotate": 0,
        "left": 705.4545454545455,
        "scaleX": 1,
        "scaleY": 1,
        "editable": false,
        "zoom": 1,
        "width": 509.09090909090907,
        "color": "#ff0000",
        "height": 195.45454545454547,
        "opacity": 1,
        "fw": "900",
        "fs": 195,
        "align": "center",
        "fontfamily": "Poppins",
        "textTransform": "",
        "italic": true,
        "underline": false,
        "lock": false,
        "lineHeight": "1",
        "effectType": {
            "type": "hollow",
            "thickness": "53"
        },
        "animationClassIn": "",
        "animationClassOut": "",
        "animationClass": "",
        "animationClassLoop": "",
        "animationDelayIn": 0,
        "animationDurationIn": 2,
        "animationDelayOut": 0,
        "animationDurationOut": 2,
        "animationDelay": 0,
        "animationDuration": 2,
        "animationLoop": false,
        "animationLoopDuration": 2
    },
    {
        "id": "ellipse_8341537d-d8dc-4a5f-82c8-ec2b9c58eaad",
        "type": "text",
        "text": [
            "Welcome !"
        ],
        "top": 449.6590909090909,
        "rotate": 0,
        "left": 529.3181818181818,
        "scaleX": 1,
        "scaleY": 1,
        "editable": false,
        "zoom": 1,
        "width": 861.3636363636364,
        "color": "#ff0000",
        "height": 180.6818181818182,
        "opacity": 1,
        "fw": 400,
        "fs": 151,
        "align": "center",
        "fontfamily": "Bungee Outline",
        "textTransform": "",
        "italic": false,
        "underline": false,
        "lock": false,
        "lineHeight": "1",
        "effectType": {
            "type": "neon",
            "intensity": "1"
        },
        "animationClassIn": "",
        "animationClassOut": "",
        "animationClass": "",
        "animationClassLoop": "",
        "animationDelayIn": 0,
        "animationDurationIn": 2,
        "animationDelayOut": 0,
        "animationDurationOut": 2,
        "animationDelay": 0,
        "animationDuration": 2,
        "animationLoop": false,
        "animationLoopDuration": 2
    },
    {
        "id": "ellipse_bba5292d-bbea-4d4e-a5fd-dad402e11d44",
        "type": "text",
        "text": [
            "Thank\nYou!"
        ],
        "top": 359.8863636363636,
        "rotate": 0,
        "left": 778.1818181818182,
        "scaleX": 1,
        "scaleY": 1,
        "editable": false,
        "zoom": 1,
        "width": 363.6363636363636,
        "color": "#4937d5",
        "height": 360.22727272727275,
        "opacity": 1,
        "fw": 400,
        "fs": 150,
        "align": "center",
        "fontfamily": "Anton",
        "textTransform": "",
        "italic": false,
        "underline": false,
        "lock": false,
        "lineHeight": "1",
        "effectType": {
            "type": "none"
        },
        "animationClassIn": "",
        "animationClassOut": "",
        "animationClass": "",
        "animationClassLoop": "",
        "animationDelayIn": 0,
        "animationDurationIn": 2,
        "animationDelayOut": 0,
        "animationDurationOut": 2,
        "animationDelay": 0,
        "animationDuration": 2,
        "animationLoop": false,
        "animationLoopDuration": 2
    },
    {
        "id": "text_d05fb3ae-ea66-4bca-bc35-6d96dc98362f",
        "type": "text",
        "text": [
            "Skyline"
        ],
        "top": 181.8181818181818,
        "rotate": 0,
        "left": 514.7727272727273,
        "scaleX": 1,
        "scaleY": 1,
        "editable": false,
        "zoom": 1,
        "width": 846.5909090909091,
        "color": "#ffd500",
        "height": 300,
        "opacity": 1,
        "fw": 500,
        "fs": 300,
        "align": "center",
        "fontfamily": "Sacramento",
        "textTransform": "",
        "italic": false,
        "underline": false,
        "lock": false,
        "lineHeight": "1",
        "effectType": {
            "type": "neon",
            "intensity": "90"
        },
        "animationClassIn": "",
        "animationClassOut": "",
        "animationClass": "",
        "animationClassLoop": "",
        "animationDelay": 0,
        "animationDuration": 2,
        "animationDelayIn": 0,
        "animationDurationIn": 2,
        "animationDelayOut": 0,
        "animationDurationOut": 2,
        "animationLoopDuration": 2,
        "animationLoop": false
    },
    {
        "id": "text_d05fb3ae-ea66-4bca-bc35-6d96dc98362f",
        "type": "text",
        "text": [
            "HAPPY HOUR!"
        ],
        "top": 197.72727272727272,
        "rotate": 0,
        "left": 521.5909090909091,
        "scaleX": 1,
        "scaleY": 1,
        "editable": false,
        "zoom": 1,
        "width": 861.3636363636364,
        "color": "#ff0000",
        "height": 400,
        "opacity": 1,
        "fw": 500,
        "fs": 200,
        "align": "center",
        "fontfamily": "Monoton",
        "textTransform": "",
        "italic": false,
        "underline": false,
        "lock": false,
        "lineHeight": "1",
        "effectType": {
            "type": "neon",
            "intensity": "90"
        },
        "animationClassIn": "",
        "animationClassOut": "",
        "animationClass": "",
        "animationClassLoop": "",
        "animationDelay": 0,
        "animationDuration": 2,
        "animationDelayIn": 0,
        "animationDurationIn": 2,
        "animationDelayOut": 0,
        "animationDurationOut": 2,
        "animationLoopDuration": 2,
        "animationLoop": false
    },
    {
        "id": "text_d05fb3ae-ea66-4bca-bc35-6d96dc98362f",
        "type": "text",
        "text": [
            "Hot Chili"
        ],
        "top": 35.22727272727273,
        "rotate": 0,
        "left": 12.5,
        "scaleX": 1,
        "scaleY": 1,
        "editable": false,
        "zoom": 1,
        "width": 245.45454545454547,
        "color": "#ff0000",
        "height": 200,
        "opacity": 1,
        "fw": "900",
        "fs": 100,
        "align": "center",
        "fontfamily": "Borel",
        "textTransform": "",
        "italic": false,
        "underline": false,
        "lock": false,
        "lineHeight": "1.1",
        "effectType": {
            "type": "echo",
            "color": "rgb(255,255,255)",
            "offset": "27",
            "direction": "-55"
        },
        "animationClassIn": "",
        "animationClassOut": "",
        "animationClass": "",
        "animationClassLoop": "",
        "animationDelay": 0,
        "animationDuration": 2,
        "animationDelayIn": 0,
        "animationDurationIn": 2,
        "animationDelayOut": 0,
        "animationDurationOut": 2,
        "animationLoopDuration": 2,
        "animationLoop": false
    },
    {
        "id": "text_f18a1be2-034a-4f05-b5dc-2ac51fc035c3",
        "type": "text",
        "text": [
            "NEON"
        ],
        "top": 325,
        "rotate": 0,
        "left": 594.3181818181819,
        "scaleX": 1,
        "scaleY": 1,
        "editable": false,
        "zoom": 1,
        "width": 673.8636363636364,
        "color": "#ff8800",
        "height": 169.3181818181818,
        "opacity": 1,
        "fw": 500,
        "fs": 235,
        "align": "center",
        "fontfamily": "Nunito",
        "textTransform": "",
        "italic": false,
        "underline": false,
        "lock": false,
        "lineHeight": "1",
        "effectType": {
            "type": "neon",
            "intensity": "95"
        },
        "animationClassIn": "",
        "animationClassOut": "",
        "animationClass": "",
        "animationClassLoop": "",
        "animationDelay": 0,
        "animationDuration": 2,
        "animationDelayIn": 0,
        "animationDurationIn": 2,
        "animationDelayOut": 0,
        "animationDurationOut": 2,
        "animationLoopDuration": 2,
        "animationLoop": false
    },
    {
        "id": "text_5426875f-94d1-4c93-95d2-f3165ebc8341",
        "type": "text",
        "text": [
            "SUPER HERO"
        ],
        "top": 329.54545454545456,
        "rotate": 0,
        "left": 396.59090909090907,
        "scaleX": 1,
        "scaleY": 1,
        "editable": false,
        "zoom": 1,
        "width": 1125,
        "color": "#000000",
        "height": 109.80392156862744,
        "opacity": 1,
        "fw": "700",
        "fs": 173,
        "align": "center",
        "fontfamily": "Work Sans",
        "textTransform": "uppercase",
        "italic": true,
        "underline": false,
        "lock": false,
        "lineHeight": "1",
        "effectType": {
            "type": "glitch",
            "color": "rgb(255, 0, 255)",
            "offset": "98",
            "direction": "90"
        },
        "animationClassIn": "",
        "animationClassOut": "",
        "animationClass": "",
        "animationClassLoop": "",
        "animationDelay": 0,
        "animationDuration": 2,
        "animationDelayIn": 0,
        "animationDurationIn": 2,
        "animationDelayOut": 0,
        "animationDurationOut": 2,
        "animationLoopDuration": 2,
        "animationLoop": false
    },
    {
        "id": "text_9ae379d6-a957-42cb-8f51-051a57708b07",
        "type": "text",
        "text": [
            "TIME OUT"
        ],
        "top": 204.54545454545453,
        "rotate": 0,
        "left": 815.9090909090909,
        "scaleX": 1,
        "scaleY": 1,
        "editable": false,
        "zoom": 1,
        "width": 509.09090909090907,
        "color": "#4c00ff",
        "height": 150,
        "opacity": 1,
        "fw": 500,
        "fs": 150,
        "align": "center",
        "fontfamily": "Anton",
        "textTransform": "",
        "italic": false,
        "underline": false,
        "lock": false,
        "lineHeight": "1",
        "effectType": {
            "type": "splice",
            "color": "#49b2f7",
            "offset": "63",
            "direction": "89",
            "thickness": "41"
        },
        "animationClassIn": "",
        "animationClassOut": "",
        "animationClass": "",
        "animationClassLoop": "",
        "animationDelay": 0,
        "animationDuration": 2,
        "animationDelayIn": 0,
        "animationDurationIn": 2,
        "animationDelayOut": 0,
        "animationDurationOut": 2,
        "animationLoopDuration": 2,
        "animationLoop": false
    }
]